<template>
    <div class="align-content-right">
        <slot></slot>
    </div>
</template>
<style>
.align-content-right {
    display: flex;
    justify-content: flex-end;
}
</style>
